import React, { PureComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Table } from "reactstrap";
import PrintArea from "../../../common/component/PrintArea";
import PrintHeader from "../../../common/component/PrintHeader";
import { SafeBig } from "../../../common/function/safeBig";
import { showQty } from "../../../common/function/showValueHelper";

type DebitMemoDeliveryPrintState = {
    data: any;
    companyInfo: any;
};

class DebitMemoDeliveryPrint extends PureComponent<WithTranslation, DebitMemoDeliveryPrintState> {
    constructor(props: any) {
        super(props);

        //load data from localStorage
        const stringData = localStorage.getItem("debitMemoDelivery-print");
        const jsonData = stringData != null ? JSON.parse(stringData) : null;

        // remove data from localStorage
        localStorage.removeItem("debitMemoDelivery-print");

        // console.log(jsonData);

        this.state = {
            data: jsonData && jsonData.data ? jsonData.data : null,
            companyInfo: jsonData && jsonData.companyInfo ? jsonData.companyInfo : null,
        };
    }

    render() {
        const { t } = this.props;
        const { companyInfo, data } = this.state;
        if (data == null) return <p>No Data</p>;
        let totalQty = SafeBig(0);
        let columns = data.detailList.map((obj: any, index: number) => {
            let pUnitToSmallestUnitCompare = SafeBig(obj.productUnitConversion?.qty ?? 1).div(obj.product.smallestUnitConversion?.qty ?? 1);
            totalQty = totalQty.plus(SafeBig(obj.qty));
            return (
                <tr key={"detail-" + index}>
                    <td className="rowNo">{index + 1}</td>
                    <td>{obj.product.name}</td>
                    <td className="qty">
                        {obj.unit == null ? (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " "}</td>
                                        <td>{obj.product?.unit?.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <table className="printQtyTable">
                                <tbody>
                                    { !obj.product.smallestUnit || obj.unit.id === obj.product.smallestUnit?.id ? (
                                        <tr>
                                            <td>{showQty(obj.qty) + " " + obj.unit?.name} @{ showQty(obj.productUnitConversion.qty) + " " + obj.product?.unit?.name } </td>
                                            <td>{showQty(SafeBig(obj.qty ?? 0).times(obj.productUnitConversion?.qty ?? 1)) + " " + obj.product.unit?.name}</td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td>{showQty(obj.qty) + " " + obj.unit?.name} @{ showQty(pUnitToSmallestUnitCompare) + " " + obj.product.smallestUnit?.name } </td>
                                            <td>{showQty(SafeBig(obj.qty ?? 0).times(pUnitToSmallestUnitCompare ?? 1)) + " " + obj.product.smallestUnit?.name}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </td>
                </tr>
            );
        });

        return (
            <PrintArea>
                <Table className="ra-table-print">
                    <PrintHeader
                        title={t("common.debitMemoDelivery")}
                        companyInfo={companyInfo}
                        supplier={data.supplier}
                        no={data.key}
                        dtCreated={data.dtCreated}
                    />
                    <tbody>
                        <tr>
                            <td colSpan={2}>
                                <Table className="ra-table-detail-print">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>{t("common.product")}</th>
                                            <th>{t("common.qty")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {columns}
                                        <tr>
                                            <td colSpan={2} style={{ textAlign: "right" }}>{t("common.totalQty")}</td>
                                            <td>{showQty(totalQty.toString(), 2)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <div>
                                    {t("common.notes")}: {data.description}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </PrintArea>
        );
    }
}

export default withTranslation()(DebitMemoDeliveryPrint);
